var _rect, _path, _path2, _g, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMagicWand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.29395,
    y: 31.8135,
    width: 24.6195,
    height: 4.75112,
    rx: 2.37556,
    transform: "rotate(-45 9.29395 31.8135)",
    fill: "url(#paint0_linear_13579_120156)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.9473 10.3251C34.1816 10.2705 34.3919 10.4808 34.3372 10.7151L33.2142 15.53C33.195 15.6124 33.2087 15.6991 33.2525 15.7716L35.8084 20.0038C35.9328 20.2097 35.7978 20.4747 35.5581 20.4951L30.6318 20.915C30.5474 20.9222 30.4692 20.962 30.4138 21.026L27.1786 24.7647C27.0211 24.9466 26.7274 24.9001 26.6339 24.6784L24.7123 20.123C24.6794 20.045 24.6173 19.9829 24.5393 19.95L19.9839 18.0284C19.7622 17.9349 19.7157 17.6412 19.8976 17.4838L23.6363 14.2485C23.7003 14.1931 23.7402 14.1149 23.7474 14.0306L24.1672 9.10429C24.1876 8.86457 24.4526 8.72956 24.6585 8.85394L28.8908 11.4099C28.9632 11.4536 29.0499 11.4674 29.1324 11.4481L33.9473 10.3251Z",
    fill: "#FED243"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_13579_120156",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 8,
    width: 17,
    height: 17
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9473 10.3251C34.1816 10.2705 34.3919 10.4808 34.3372 10.7151L33.2142 15.53C33.195 15.6124 33.2087 15.6991 33.2525 15.7716L35.8084 20.0038C35.9328 20.2097 35.7978 20.4747 35.5581 20.4951L30.6318 20.915C30.5474 20.9222 30.4692 20.962 30.4138 21.026L27.1786 24.7647C27.0211 24.9466 26.7274 24.9001 26.6339 24.6784L24.7123 20.123C24.6794 20.045 24.6173 19.9829 24.5393 19.95L19.9839 18.0284C19.7622 17.9349 19.7157 17.6412 19.8976 17.4838L23.6363 14.2485C23.7003 14.1931 23.7402 14.1149 23.7474 14.0306L24.1672 9.10429C24.1876 8.86457 24.4526 8.72956 24.6585 8.85394L28.8908 11.4099C28.9632 11.4536 29.0499 11.4674 29.1324 11.4481L33.9473 10.3251Z",
    fill: "#FED243"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_13579_120156)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_13579_120156)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.29395,
    y: 31.8135,
    width: 24.6195,
    height: 4.75112,
    rx: 2.37556,
    transform: "rotate(-45 9.29395 31.8135)",
    fill: "url(#paint1_linear_13579_120156)",
    fillOpacity: 0.6
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3082 7.60757L19.7636 7.01136L19.212 9.47715C19.1665 9.68077 19.2022 9.89413 19.3117 10.0718L20.6375 12.2227L18.122 12.4601C17.9142 12.4797 17.7224 12.5797 17.5873 12.7387L15.9513 14.6643L14.9481 12.3452L14.4892 12.5437L14.9481 12.3452C14.8653 12.1537 14.7109 12.0021 14.518 11.9228L14.3278 12.3852L14.518 11.9228L12.1811 10.9619L14.0767 9.29122C14.2332 9.15326 14.3297 8.95961 14.3455 8.75156L14.5372 6.23212L16.7119 7.51866C16.8915 7.62491 17.1054 7.65681 17.3082 7.60757ZM16.0788 14.9591L16.0786 14.9587L16.0788 14.9591ZM11.884 10.8397C11.8841 10.8398 11.8842 10.8398 11.8843 10.8399L11.884 10.8397ZM14.2607 6.06856L14.261 6.06871C14.2609 6.06866 14.2608 6.06861 14.2607 6.06856L14.3624 5.89667L14.2607 6.06856Z",
    fill: "#FED243",
    fillOpacity: 0.8,
    stroke: "#FED243"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.18451 16.2256L8.73188 16.2759L9.18451 16.2256L9.02873 14.8231L10.3555 15.3039C10.5517 15.375 10.7678 15.3666 10.9579 15.2806L12.2437 14.6991L12.1965 16.1095C12.1895 16.318 12.2642 16.521 12.4047 16.6752L13.3552 17.7184L11.9992 18.1093C11.7987 18.1671 11.6287 18.3009 11.5254 18.4822L10.8271 19.7084L10.0363 18.5396L9.62218 18.8198L10.0363 18.5396C9.91938 18.3668 9.73959 18.2465 9.53524 18.2043L8.15319 17.919L9.02044 16.8058C9.14867 16.6412 9.20754 16.433 9.18451 16.2256Z",
    fill: "#FED243",
    fillOpacity: 0.5,
    stroke: "#FED243"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_13579_120156",
    x: 2.27832,
    y: 7.38867,
    width: 34.7998,
    height: 34.8008,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_13579_120156"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13579_120156",
    x1: 33.6565,
    y1: 34.0816,
    x2: 9.20673,
    y2: 34.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0357612,
    stopColor: "#830000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13579_120156",
    x1: 33.6565,
    y1: 34.0816,
    x2: 9.20673,
    y2: 34.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0357612,
    stopColor: "#830000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB0000"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicWand);
export default __webpack_public_path__ + "static/media/magic-wand.416f4e73b2c47e13a4026e5b0b54f221.svg";
export { ForwardRef as ReactComponent };